import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import "./App.css";
import Layout from "./layout";
import Thankyou from "./pages/thankyou";
import 'semantic-ui-css/semantic.min.css';
import Charted from "./pages/charted";
import Customer from "./pages/customer";
import User from "./pages/user";

function App() {
  const ChartedRoute = () => (
    <Layout>
      <Charted />
    </Layout>
  );
  const UserRoute = () => (
    <Layout>
      <User />
    </Layout>
  );
    const CustomerRoute = () => (
    <Layout>
      <Customer />
    </Layout>
  );
  const ThankyouRoute = () => (
    <Layout>
      <Thankyou />
    </Layout>
  );
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route exact path={["/","/register"]} as="/register" component={CustomerRoute} />
          <Route exact path={"/ca"} component={ChartedRoute} />
          <Route exact path={"/user"} component={UserRoute} />
          <Route exact path={"/thankyou"} component={ThankyouRoute} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
